import React from "react";
import { RANKS, getRank } from "../lib/gameLogic";

export default function RankLadder({ level }) {
  const currentRank = getRank(level);
  return (
    <div
      className="border border-white/10 bg-[#0A0D14] p-5 md:p-6"
      data-testid="rank-ladder"
    >
      <div className="text-[10px] uppercase tracking-[0.3em] text-blue-400/80">
        // Hierarchy
      </div>
      <h3 className="font-display uppercase font-bold text-xl mt-1">
        The Ladder
      </h3>
      <ul className="mt-4 space-y-1.5">
        {RANKS.map((r) => {
          const isCurrent = r.code === currentRank.code;
          const unlocked = level >= r.minLevel;
          return (
            <li
              key={r.code}
              className={`flex items-center gap-3 border ${
                isCurrent
                  ? "border-purple-400/60 bg-purple-500/10"
                  : unlocked
                    ? "border-white/10 bg-black/30"
                    : "border-white/5 bg-black/20"
              } p-2.5`}
              data-testid={`rank-row-${r.code}`}
            >
              <div
                className="h-8 w-8 border flex items-center justify-center font-display font-black text-sm"
                style={{
                  color: unlocked ? r.color : "#475569",
                  borderColor: unlocked ? r.color : "#1e293b",
                }}
              >
                {r.code}
              </div>
              <div className="flex-1 min-w-0">
                <div
                  className={`font-display uppercase tracking-wider text-xs ${
                    unlocked ? "text-white" : "text-slate-600"
                  }`}
                >
                  {r.name}
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-mono">
                  LV {r.minLevel}+
                </div>
              </div>
              {isCurrent && (
                <div className="text-[9px] font-mono uppercase tracking-[0.3em] text-purple-300">
                  // You
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
